module.exports = __webpack_public_path__ + "img/KatzenMama.b088b06e.svg";